<template>
  <div class="row">
    <div class="col s9">
      <div class="col s12 z-depth-1 white">
        <div class="row">
          <div class="left" style="padding-top: 10px;">
            <span class="title" style="padding-left: 11px;">{{ $t('analysis.sectionAnalysis') }}</span>
          </div>
        </div>
        <SectionChart
          :railObject="railObject"
          :apiData="apiData"
          :date-from="dateFrom"
          :date-to="dateTo"
          :property="property"
          :section="section"
          :direction="direction"
          @updated="updatePropertiesSections"
        />
      </div>
    </div>
    <div class="col s3">
      <div class="control col s12 z-depth-1 white">
        <div class="input-field">
          {{ $t('analysis.direction') }}:
          <select v-model="direction" class="browser-default">
            <option v-for="direction in directions" :value="direction.key" :key="direction.key">
              {{ direction.label }}
            </option>
          </select>
        </div>
        <div class="input-field">
          {{ $t('analysis.section') }}:
          <select v-model="section" class="browser-default">
            <option v-for="s in sections" :value="s" :key="s">
              {{ s }}
            </option>
          </select>
        </div>
        <div class="input-field">
          {{ $t('analysis.property') }}:
          <select v-model="property" class="browser-default">
            <option v-for="property in properties" :value="property.name" :key="property.id">
              {{ property.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchApi from '../../../services/api/switch/SwitchApi'
import SectionChart from './SectionChart'

export default {
  name: 'SectionAnalysis',
  components: {
    SectionChart
  },
  props: {
    railObject: {
      required: true
    },
    dateFrom: {
      required: true
    },
    dateTo: {
      required: true
    }
  },
  data () {
    return {
      apiData: [],
      property: '',
      section: '',
      direction: '0',
      directions: [
        { key: '0', label: 'N' },
        { key: '1', label: 'R' }
      ],
      properties: [],
      sections: []
    }
  },
  created: function () {
    this.getApiData(true)
  },
  computed: {},
  methods: {
    getApiData (images) {
      if (this.railObject) {
        this.getSectionData()
      }
    },
    getSectionData () {
      SwitchApi.getSwitchSectionAnalysisData(
        this.railObject.RailObjectId,
        this.dateFrom,
        this.dateTo)
        .then(result => {
          this.apiData = result.data
        })
    },
    updatePropertiesSections ({properties, sections}) {
      this.properties = properties
      this.sections = sections

      if (this.sections.length > 0) {
        this.section = this.sections[0]
      }
      if (this.properties.length > 0) {
        this.property = this.properties[0].name
      }
    }
  },
  watch: {
    railObject (val) {
      if (val) {
        this.getApiData(true)
      }
    },
    dateFrom () {
      this.getApiData(false)
    },
    dateTo () {
      this.getApiData(false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/switch/analysis/SectionAnalysis.vue